import React from "react";
import { IconTrendingUp, IconTrendingDown, IconMinus } from "@tabler/icons-react";

const formatValue = (value, format) => {
  if (value === null || value === undefined) return "—";
  if (typeof value === "number" && isNaN(value)) return "—";
  switch (format) {
    case "currency":
      return new Intl.NumberFormat("pt-BR", {
        style: "currency", currency: "BRL", minimumFractionDigits: 2,
      }).format(Number(value));
    case "percentage":
      return `${Number(value).toFixed(2)}%`;
    case "duration": {
      const secs = Number(value);
      if (!secs || isNaN(secs)) return "—";
      if (secs < 60) return `${Math.round(secs)}s`;
      if (secs < 3600) return `${Math.round(secs / 60)}min`;
      const h = Math.floor(secs / 3600);
      const m = Math.round((secs % 3600) / 60);
      return m > 0 ? `${h}h ${m}min` : `${h}h`;
    }
    default:
      return new Intl.NumberFormat("pt-BR").format(Number(value));
  }
};

const KPICard = ({ label, kpi, icon: Icon, color, hint }) => {
  if (!kpi) return null;
  const { value, previous_value, growth_percentage, trend, format } = kpi;

  const TrendIcon =
    trend === "positive" ? IconTrendingUp :
    trend === "negative" ? IconTrendingDown : IconMinus;

  const trendClass =
    trend === "positive" ? "kpi-card__trend--positive" :
    trend === "negative" ? "kpi-card__trend--negative" : "kpi-card__trend--neutral";

  const showComparison =
    previous_value !== null && previous_value !== undefined;
  const showGrowth =
    showComparison &&
    growth_percentage !== null &&
    growth_percentage !== undefined;

  return (
    <div className="kpi-card fade-in">
      <div className="kpi-card__head">
        {Icon && (
          <div className="kpi-card__icon" style={color ? { background: color } : undefined}>
            <Icon size={18} />
          </div>
        )}
        {showGrowth ? (
          <div className={`kpi-card__trend ${trendClass}`}>
            <TrendIcon size={12} />
            <span>{growth_percentage > 0 ? "+" : ""}{growth_percentage}%</span>
          </div>
        ) : showComparison && previous_value === 0 && Number(value) > 0 ? (
          // current cresceu de zero — não tem % matemático
          <div className="kpi-card__trend kpi-card__trend--positive">
            <TrendIcon size={12} />
            <span>novo</span>
          </div>
        ) : null}
      </div>
      <div className="kpi-card__value">{formatValue(value, format)}</div>
      <div className="kpi-card__label">{label}</div>
      {showComparison && (
        <div className="kpi-card__previous">
          vs {formatValue(previous_value, format)} no período anterior
        </div>
      )}
      {hint && <div className="kpi-card__hint">{hint}</div>}
    </div>
  );
};

export default KPICard;
